import RadioGroup from '@components/molecules/RadioGroup';
import { VehicleType, VehicleUtilization } from '@graphql/generated';
import {
  QuoteInitialForm,
  VehicleUtilizationTypeFormResult,
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import { FC } from 'react';
import { useForm } from 'react-hook-form';

interface FormResult {
  utilization: VehicleUtilization[];
}

interface Props {
  onSubmit: (data: VehicleUtilizationTypeFormResult) => void;
  item: QuoteInitialForm;
}

const SuhaiUtilizationForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } = useForm<FormResult>();

  const submit = ({ utilization }: FormResult) => {
    if (item.vehicle) {
      onSubmit({
        vehicle: {
          ...item.vehicle,
          utilization,
          workParking:
            utilization.includes(VehicleUtilization.Delivery) ||
            utilization.includes(VehicleUtilization.App) ||
            utilization.includes(VehicleUtilization.Taxi) ||
            !utilization.includes(VehicleUtilization.Commuting) ||
            !utilization.includes(VehicleUtilization.Work)
              ? null
              : item.vehicle?.workParking,

          schoolParking: !utilization.includes(VehicleUtilization.School)
            ? null
            : item.vehicle?.schoolParking,
        },
      });
    }
  };

  const options = [
    {
      label: 'Particular - Locomoção/ida-retorno local fixo de trabalho/Lazer',
      value: VehicleUtilization.Commuting,
    },
    {
      label: 'Particular - Atividade profissional',
      value: VehicleUtilization.Work,
    },
    {
      label: 'Particular - Lazer exclusivamente',
      value: VehicleUtilization.Leisure,
    },
    {
      label:
        item.vehicle?.type === VehicleType.Motorcycle
          ? 'Moto Táxi'
          : 'Táxi',
      value: VehicleUtilization.Taxi,
    },
    {
      label: 'Moto-Fretistas/Moto-Entregadores ',
      value: VehicleUtilization.Delivery,
    },
    {
      label: 'Transporte de passageiros por aplicativo',
      value: VehicleUtilization.App,
    },

    {
      label: 'Outros',
      value: 'others' as VehicleUtilization,
    },
  ].filter(({ value }) => {
    if (item.vehicle?.type === VehicleType.Car)
      return ![VehicleUtilization.Sport, VehicleUtilization.Delivery].includes(
        value,
      );

    if (item.vehicle?.type === VehicleType.Motorcycle)
      return ![VehicleUtilization.App].includes(value);

    return true;
  });
  return (
    <form onSubmit={handleSubmit(submit)}>
      <GridBox justifyContent="center">
        <GridBox width={[1, 1, 1]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            errorMessage={(errors.utilization as any)?.message}
            onSelected={(value) => {
              if (value === 'others') {
                alert('Cálculo não disponível para esse tipo de utilização');
                return;
              }
              submit({
                utilization: [value as VehicleUtilization],
              });
            }}
            name="utilization"
            options={options.map((o) => {
              if (item.vehicle?.utilization?.includes(o.value))
                return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>
    </form>
  );
};

export default SuhaiUtilizationForm;
